import React from 'react';
import InputBase, { InputStart, InputEnd } from 'styles/basic/InputBase';
import Flex from 'mrf/layout/Flex';
import IF from 'mrf/view/IF';
import ELSE from 'mrf/view/ELSE';

export default function Input({
    start,
    end,
    error,
    disabled,
    readOnly,
    color,
    required,
    howToRenderMe = o => o,
    component: Component = InputBase,
    ...props
}) {
    return <Flex gap={0} width='auto'>
        <IF condition={!!readOnly}>
            <p>&nbsp;{howToRenderMe(props.value)}</p>
        </IF>
        <ELSE condition={!!readOnly}>
            {start && <InputStart
                width='auto'
                error={error}
                color={color}
            >
                {start}
            </InputStart>}
            <Component
                as='input'
                start={start}
                end={end}
                error={error}
                disabled={disabled}
                required={required}
                color={color}
                {...props}
            />
            {end && <InputEnd
                width='auto'
                error={error}
                color={color}
            >
                {end}
            </InputEnd>}
        </ELSE>
    </Flex>
}
